const chatDictionary = {
  createChat: () => `api/v1/chat/create`,
  getAllChats: () => `api/v1/chat/sessions`,
  sendMessage: (chatId: string) => `api/v1/chat/${chatId}/message`,
  getMessages: (body: any) => `api/v1/chat/${body.chatId}/messages?limit=${body.limit}`,
  getChatStatus: () => `api/v1/user-application/chat-status`,
};

export default chatDictionary;
